<svelte:options tag="and-button" ></svelte:options>
<link rel="stylesheet" href="and-component-styles.css" {disabled}/>

<style type="text/scss" lang="scss" >
@import '../../global.scss';
.storybook-button {
  font-family: 'Poppins', sans-serif;
  @include fontSize(16px);
  border: 0;
  min-width: toRem(100px);
  min-height: toRem(40px);
  border-radius: toRem(10px);
  cursor: pointer;
  display: inline-block;
  line-height: 1;
  padding: toRem(8px) toRem(23px);
}

.storybook-button--primary {
  color: white;
  background-color: $color-primary;

  &:hover {
    background: darken($color-primary, 15%);
  }

  &:focus {
    outline: 0;
    background: darken($color-primary, 30%);
  }

  &:disabled {
    color:$color-primary;
    background: lighten($color-primary, 30%);
  }
}

.storybook-button--secondary {
  color: white;
  background-color: $color-secondary;

  &:hover {
    background: darken($color-secondary, 15%);
  }

  &:focus {
    background: darken($color-secondary, 30%);
  }

  &:disabled {
    color:$color-secondary;
    background: lighten($color-secondary, 30%);
  }
}


</style>

<script>
  import { createEventDispatcher } from 'svelte';
  import { get_current_component } from "svelte/internal"
  import eventDispatcher from '../../EventDispatcher.js';
  /**
   * Is this a primary button
   */
  export let primary;
  export let type = "button"

  /**
   * Button contents
   */
  export let label = '';

  export let id = "and-button";

  let class_name = '';

  let disabled_state = false;

  export  { class_name as class };

  export  { disabled_state as disabled };
  
  export let overidestyle = false;

  $: disabled = overidestyle ? null : true;

  $: mode = primary ? 'storybook-button--primary' : 'storybook-button--secondary';

  $: isDisabled =  disabled_state ? "true" : "";

  const component = get_current_component()
  const dispatch = createEventDispatcher()

  /**
   * Optional click handler
   */
  function onClick(event) {
    dispatch('click', event);
    eventDispatcher.dispatchCustomEvent(component, event, 'click');
  }
</script>

<button
  id={id}
  type={type}
  class={['storybook-button',  mode , class_name].join(' ')}
  on:click={onClick} disabled={isDisabled}>
  {label}
</button>
